import Swal from 'sweetalert2';
import { history } from '../_helpers';

const alerts = {
    success,
    warning,
    html,
    error,
    confirmation,
    waiting,
    alert,
    clean
};

function alert(message) {
    const Toast = Swal.mixin({
        toast: true,
        position: 'top-end',
        showConfirmButton: false,
        timer: 3000,
        timerProgressBar: true,
        heightAuto: false,
        onOpen: (toast) => {
            toast.addEventListener('mouseenter', Swal.stopTimer);
            toast.addEventListener('mouseleave', Swal.resumeTimer);
        }
    });

    Toast.fire({
        icon: 'warning',
        title: message
    });
}

function clean() {
    Swal.close();
}

function waiting(message) {
    Swal.fire({
        title: 'Aguarde',
        text: message,
        heightAuto: false,
        onBeforeOpen: () => {
            Swal.showLoading();
        }
    });
}

function success(message, redirect = null) {

    Swal.fire({
        title: 'Sucesso!',
        text: message,
        icon: 'success',
        confirmButtonText: 'Ok',
        heightAuto: false,
        onClose: () => {
            if (redirect) window.location.href = redirect;
        }
    });

}

function html(message, path) {

    Swal.fire({
        title: 'Sucesso!',
        html: message,
        icon: 'success',
        confirmButtonText: 'Ok',
        heightAuto: false
    }).then((result) => {
        history.push(path);
    });

}

function warning(message) {

    Swal.fire({
        title: 'Atenção!',
        html: message,
        icon: 'warning',
        confirmButtonText: 'Ok',
        heightAuto: false
    });

}

function error(message) {

    Swal.fire({
        title: 'Erro!',
        text: message,
        icon: 'error',
        confirmButtonText: 'Ok',
        heightAuto: false
    });

}

function confirmation(message) {

    Swal.fire({
        title: 'Confirmação',
        text: message,
        icon: 'warning',
        buttons: true,
        dangerMode: true,
        heightAuto: false
    })
        .then((willDelete) => {
           // console.log('willDelete', willDelete);
            return willDelete;
        });

}

export default alerts;